<template>
    <div class="training-page">
      <Header></Header>
      <div class="training-info pt-15">
        <div class="container">
       <div class="sec-wrapper d-flex justify-content-between">
        <div class=""> 
          <h2 id="famous-companies" class="section-title">التدريبات</h2>
            <ul class="d-flex"> 
              <li class="link-section-title"> <a  >كل التدريبات  </a> </li>
              <li class="link-section-title"> <a>نظافة</a> </li>
              <li class="link-section-title"> <a>صيانة</a> </li>
              <li class="link-section-title"> <a>أغذية</a> </li>
              <li class="link-section-title"> <a>تعقيم</a> </li>
            </ul>
        </div>
        <div class="mt-3"> 
          <b-form-input
            v-model="search"
            type="text"
            class="form-input"
            placeholder="بحث "
          />
        </div>

      </div>
      <!-- card for Programs -->
      <div 
 class="d-flex flex-row  justify-content-start flex-wrap mx-0 px-0"
 >
        <div v-for="program in programsData" :key="program.id">
          <ProgramCard
              :imageUrl="program.image.url"
              :imageAlt="program.type"
              :title="program.title"
              :description="program.description"
              :buttonText="'تفاصيل أكتر'"
              :linkToDetail="`/training-program/${program.id}`"
              :linkTo="`/training-program/${program.id}`"
            />
            
        </div>

     
      </div>


        <b-row 
        >
          <b-col
            cols="12"
            sm="12"
        class="d-flex align-items-center justify-content-center py-2"

          >

            <!-- pagination -->
     
  <div >
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
    ></b-pagination>
  </div>
          
                 
          </b-col>
        </b-row>
            
      
      </div>
    </div>
      <Footer></Footer>
    </div>
  </template>
  <script>
  import Header from "@/components/Company/Header.vue";
  import Footer from "@/components/Home/Footer.vue";
  import ProgramCard from "@/components/layout/ProgramCard.vue"
import axios from "axios";


  export default {
    components: { Header, Footer , ProgramCard},
    
  data() {
    return {
      programsData: [],
      perPage: 3,
        currentPage: 1,
        
  };
  },
  computed: {
      rows() {
        return 10
      }
    },
 
  created() {
    this.fetchProgramsData();
  },
  methods: {
    async fetchProgramsData() {
      try {
        const response = await axios.get(`/training_programs`);
        this.programsData = response.data.data.training_programs;
      } catch (error) {
        console.error("Error fetching training_programs data:", error);
      }
    },
  },
   
  };
  </script>
<style scoped> 
.sec-wrapper{
  margin: 20px 20px 10px 55px;
}
.section-title{
  color: #234aa5;
  font-size: 45px;
  font-weight: 600 ;
}
.link-section-title{
  color: #253d83;
  font-size: 16px;
  margin: 5px 12px;
  cursor: pointer;
  border-bottom: 1px solid transparent;
}
.link-section-title:hover{
  border-bottom: 1px solid #253d83; 
}
.form-input{
  background-color: #f5f2f2;
}
</style>